/**
 * Detection of unfilled quick-start template placeholders like "[Subject]"
 * or "[Add a target…]". Offerings must not be published while any remain.
 */

const PLACEHOLDER_RE = /\[[^[\]]+\]/;

const stripHtml = (html: string): string => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent ?? div.innerText ?? '';
};

export interface PlaceholderCheckInput {
  title?: string | null;
  description?: string | null;
  learningOutcomes?: string | null;
  prerequisites?: string | null;
}

/** Field labels that still contain [placeholder] text from a quick-start template. */
export const findLeftoverPlaceholders = (d: PlaceholderCheckInput): string[] => {
  const fields: [string, string][] = [
    ['Title', d.title ?? ''],
    ['Description', stripHtml(d.description ?? '')],
    ['Learning outcomes', stripHtml(d.learningOutcomes ?? '')],
    ['Prerequisites', stripHtml(d.prerequisites ?? '')],
  ];
  return fields.filter(([, text]) => PLACEHOLDER_RE.test(text)).map(([label]) => label);
};
